import React from 'react'

import pill from "./../../../UI/general/pill.svg"

interface Props{
    isGalleryActive: any,
    amenityData: any,
    colorsData: any,
    handleCloseGallery: any,
}

interface State{
    isCollapsed: boolean,
    currentSelectedFile: string,
    currentIndexSelected: number
}
declare const window: any;

class DetailedGallery extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentSelectedFile: "",
            isCollapsed: false,
            currentIndexSelected: 0
        }
    }

    componentDidMount(): void {
        this.setState({
            currentSelectedFile: this.props.amenityData.links[0].link
        })
    }


    render(): React.ReactNode {
        return( 
            <div className={this.props.isGalleryActive ? 'gallery-container fade-in':'gallery-container fade-out'}>
                {
                    this.props.isGalleryActive ?
                    <div className={this.state.isCollapsed ? 'gallery-file-container-wide':'gallery-file-container'}>
                        <div className='iframe-container'>
                            <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + this.state.currentSelectedFile} alt="gallery" className='gallery-file'/>
                        </div>
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-gallery-btn-collapsed':'sidebar-gallery-btn'}
                    onClick={() => {this.props.handleCloseGallery()}}
                >
                    <img src={pill} alt=""/>
                </div>
                <div className={this.state.isCollapsed ? 'sidebar-gallery-container-collapsed':'sidebar-gallery-container'}>
                    <div className='sidebar-gallery-preview-container'>
                    {
                            this.props.amenityData && this.props.amenityData.links ?
                            this.props.amenityData.links.map((render: any, index: number) =>
                                <div className='individual-tour-container' 
                                onClick = {() => {
                                    this.setState({currentSelectedFile: render.link, currentIndexSelected: index})
                                }}
                                >
                                    <div 
                                        className='individual-tour-image-container'
                                        style={{
                                            boxSizing: 'border-box',
                                            border: this.state.currentIndexSelected === index ? `0.2vw ${this.props.colorsData.main_buttons} solid`:`none`
                                        }}
                                    >
                                        <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + render.link} alt=""></img>
                                        <div className='gallery-name'>{render.name.slice(0,-5).replaceAll('_',' ')}</div>
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default DetailedGallery